import { render } from "./VendorModal.vue?vue&type=template&id=2fbdd47a&scoped=true"
import script from "./VendorModal.vue?vue&type=script&lang=js"
export * from "./VendorModal.vue?vue&type=script&lang=js"

import "./VendorModal.vue?vue&type=style&index=0&id=2fbdd47a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbdd47a"]])

export default __exports__